import React from "react";
import classnames from "classnames";
import Button from "Shared/Button";
import { translate } from "Shared/translate";
import connect from "Shared/connect";
import { getNumberWithinLimits, floatCalculationSafety, adjustNumberToMatchStep, } from "./utils";
import LoginContainer from "Shared/Login/Container";
import { setFeedback } from "SiteLayout/GenericFeedbackBar/action-creators";
import { ENTER, ESC } from "Shared/keyboard";
import shallowEquals from "Shared/shallow-equals";
import * as styles from "./base.scss";
import Icon from "Shared/Icon";
class Quantity extends React.Component {
    constructor(props) {
        super(props);
        this.keyDown = (e) => {
            if (e.keyCode === ENTER) {
                this.quantityInput.blur();
            }
            if (e.keyCode === ESC) {
                this.resetField();
            }
            if (!!this.props.keyDown) {
                this.props.keyDown(e);
            }
        };
        this.inputRef = (el) => {
            this.quantityInput = el;
            if (this.props.inputRef) {
                this.props.inputRef(el);
            }
        };
        // tslint:disable-next-line:no-empty
        this.onOkButtonClick = (e) => { };
        this.state = {
            proxyValue: this.getProxyValueFromProps(),
            hasChangedValue: false,
        };
        this.ref = React.createRef();
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = !shallowEquals(nextProps, this.props, true) ||
            !shallowEquals(nextState, this.state, true);
        return shouldUpdate;
    }
    getProxyValueFromProps() {
        const proxyValue = this.props.value || (this.props.allowEmptyQuantity ? "" : "0");
        return this.getValueAsString(proxyValue);
    }
    componentWillUnmount() {
        if (this.props.mayCommitUpdateOnUnmountIfFocused && this.isFocused) {
            this.onBlur();
        }
        this.unMounted = true;
    }
    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ proxyValue: this.getProxyValueFromProps() });
        }
        if (this.props.focus && !prevProps.focus) {
            const { proxyValue } = this.state;
            this.quantityInput.focus();
            if (!this.props.neverFocusTheValueItself &&
                !!proxyValue &&
                proxyValue !== "") {
                this.quantityInput.select();
            }
        }
    }
    getStep() {
        const { step } = this.props;
        return step > 0 ? step : 1;
    }
    getValueAsNumber(value) {
        const numericValue = parseFloat(value);
        return !isNaN(numericValue) ? numericValue : 0;
    }
    getValueAsString(value) {
        return value.toString();
    }
    change(value, action) {
        const proxyValue = this.getValueAsString(value).replace(/\,/g, ".");
        const invalidCharacters = proxyValue.replace(/\d{0,}(\.){0,1}\d{0,}/, "");
        if (proxyValue !== "" && invalidCharacters.length > 0) {
            return;
        }
        this.setState({
            proxyValue: proxyValue,
            hasChangedValue: !action,
        }, () => {
            if (action) {
                const desiredValue = this.getValueAsNumber(proxyValue);
                const allowedValue = adjustNumberToMatchStep(desiredValue, this.getStep());
                this.commitUpdate(allowedValue);
            }
        });
    }
    stepToNextQuantity(direction) {
        const { minQuantity, maxQuantity } = this.props;
        const { preFormat, postFormat } = floatCalculationSafety();
        const proxyValue = preFormat(this.getValueAsNumber(this.state.proxyValue));
        const step = preFormat(this.getStep());
        const action = direction === 1 ? "add" : "reduce";
        const quantity = postFormat(proxyValue + step * direction);
        const quantityWithinLimits = getNumberWithinLimits(quantity, minQuantity, maxQuantity);
        this.change(quantityWithinLimits, action);
        if (action === "add") {
            this.bounceAnimation();
        }
    }
    commitUpdate(quantity) {
        if (this.state.hasChangedValue) {
            this.setState({ hasChangedValue: false });
        }
        return this.props.update(quantity).catch(() => {
            if (!this.unMounted && !this.isFocused) {
                this.setState({
                    proxyValue: this.getValueAsString(this.props.value),
                });
            }
        });
    }
    bounceAnimation() {
        this.ref.current.classList.remove(styles.drop);
        this.ref.current.classList.add(styles.drop);
    }
    onFocus(e) {
        this.isFocused = true;
        e.target.select();
        if (!!this.props.selectIndex) {
            this.props.selectIndex();
        }
        if (!!this.props.onFocus) {
            this.props.onFocus(e);
        }
    }
    onBlur(e) {
        this.isFocused = false;
        if (this.state.hasChangedValue) {
            const { minQuantity, maxQuantity } = this.props;
            const desiredValue = this.getValueAsNumber(this.state.proxyValue);
            const allowedValue = adjustNumberToMatchStep(getNumberWithinLimits(desiredValue, minQuantity, maxQuantity), this.getStep());
            if (desiredValue > maxQuantity) {
                this.props.setFeedback({
                    text: translate("/Shared/QuantityAboveMaxError", maxQuantity),
                    type: "warning",
                });
            }
            else if (desiredValue < minQuantity) {
                this.props.setFeedback({
                    text: translate("/Shared/QuantityBelowMinError", minQuantity),
                    type: "warning",
                });
            }
            else if (desiredValue !== allowedValue) {
                this.props.setFeedback({
                    text: translate("/Shared/QuantityStep"),
                    type: "warning",
                });
            }
            this.setState({ proxyValue: allowedValue.toString() });
            this.commitUpdate(allowedValue);
        }
        if (!!this.props.onBlur) {
            return this.props.onBlur();
        }
    }
    resetField() {
        this.setState({
            proxyValue: this.getValueAsString(this.props.value),
        });
    }
    render() {
        const { hideButtons, className, unitShortName, disabled, isCartQuantity, minQuantity, maxQuantity, autoFocus, renderVariant, selectedVariant, useNewDesign, isCheckout, hasSubDelivery, isPantry, } = this.props;
        const { hasChangedValue, proxyValue } = this.state;
        const proxyValueNumber = this.getValueAsNumber(proxyValue);
        const appearance = [{ small: true, bare: true, round: true }];
        const disableIfValueEqualsZero = hasSubDelivery && proxyValueNumber === 0;
        return (React.createElement(LoginContainer, null, ({ isLoggedIn }) => (React.createElement("div", { ref: this.ref, className: classnames(styles.wrap, {
                [styles.useNewDesign]: this.props.useNewDesign,
                [styles.isCartQuantity]: isCartQuantity,
                [styles.disabled]: !isLoggedIn ||
                    disabled ||
                    (isCheckout &&
                        this.props.useNewDesign &&
                        disableIfValueEqualsZero),
            }, className) },
            renderVariant ||
                (unitShortName && (React.createElement("span", { className: classnames(styles.unitShortName, "ui-test-unit-short-name") }, unitShortName))),
            React.createElement("div", { className: classnames(styles.wrapInner, {
                    [styles.inCart]: proxyValueNumber > 0,
                }) },
                React.createElement("div", { className: classnames(styles.unitHolder, {
                        [styles["description--medium"]]: useNewDesign,
                    }) },
                    React.createElement("div", { className: styles.amount }, proxyValueNumber),
                    React.createElement("div", { className: styles.unit }, !!selectedVariant && selectedVariant.unitShortName)),
                !hideButtons && (React.createElement(Button, { title: translate("/Product/MinimizeQty"), appearance: appearance, onClick: () => this.stepToNextQuantity(-1), className: styles.minusbutton, disabled: !isLoggedIn ||
                        disabled ||
                        hasChangedValue ||
                        proxyValueNumber <= minQuantity ||
                        (isCheckout &&
                            this.props.useNewDesign &&
                            proxyValueNumber === 0 &&
                            disableIfValueEqualsZero) }, this.props.useNewDesign ? React.createElement(Icon, { name: "minus" }) : "-")),
                React.createElement("input", { ref: this.inputRef, type: "text", step: this.getStep(), name: "quantity", autoFocus: autoFocus, className: classnames(styles.input, className, { [styles["description--medium"]]: useNewDesign }, { [styles.useNewDesign]: useNewDesign }, { [styles.isPantryQuantity]: isPantry }), value: proxyValue, autoComplete: "off", onChange: (e) => this.change(e.target.value), onKeyDown: this.keyDown, onFocus: (e) => this.onFocus(e), onBlur: (e) => this.onBlur(e), disabled: !isLoggedIn ||
                        disabled ||
                        (isCheckout &&
                            this.props.useNewDesign &&
                            disableIfValueEqualsZero) }),
                React.createElement("div", { className: classnames(styles.unitOffset, {
                        [styles["description--medium"]]: useNewDesign,
                    }) }, !!selectedVariant && selectedVariant.unitShortName),
                !hideButtons && (React.createElement("span", { onMouseDown: (e) => (this.ignoreAddClick = hasChangedValue), onClickCapture: (e) => {
                        if (this.ignoreAddClick) {
                            /*  Since we change the hasChangedValue on input blur event which happens onMouseDown and it will change
                          the hasChangedValue state to false before the user release the mouse button and the onClick event is fired.
                          So when the click event is fired the add button is in the DOM and we will call this.add();
                          This onClickCapture event will not bubble up, but instead downwards so we are stopping it from propagating down to the button.
                      */
                            e.stopPropagation();
                        }
                    } }, hasChangedValue ? (React.createElement(Button, { title: "OK", appearance: appearance, onClick: this.onOkButtonClick, className: styles.okbutton, disabled: !isLoggedIn ||
                        disabled ||
                        (isCheckout &&
                            this.props.useNewDesign &&
                            disableIfValueEqualsZero) },
                    React.createElement("div", { className: styles.okbuttonInner }, "OK"))) : (React.createElement(Button, { title: translate("/Product/MaximizeQty"), appearance: appearance, onClick: () => this.stepToNextQuantity(1), className: styles.plusbutton, disabled: !isLoggedIn ||
                        disabled ||
                        proxyValueNumber >= maxQuantity ||
                        (isCheckout &&
                            this.props.useNewDesign &&
                            disableIfValueEqualsZero) }, this.props.useNewDesign ? React.createElement(Icon, { name: "plus" }) : "+")))))))));
    }
}
Quantity.defaultProps = { maxQuantity: 999 };
export default connect(null, (dispatch) => ({
    setFeedback: (data) => dispatch(setFeedback(data)),
}))(Quantity);
